import React from 'react'

function Cbse() {
  return (
    <div>Cbse</div>
  )
}

export default Cbse